import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  facturas: [],
  clients: [],
  currentFactura: null,
  metadata: {
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    totalPages: 0
  },
  filter: {},
  loading: false,
  error: null
};

const facturaSlice = createSlice({
  name: "facturas",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    setFacturas: (state, action) => {
      state.facturas = action.payload.data;
      state.metadata = action.payload.meta;
      state.loading = false;
    },
    setClients: (state, action) => {
      state.clients = Array.isArray(action.payload)
        ? action.payload
        : action.payload?.data || [];
    },
    setCurrentFactura: (state, action) => {
      state.currentFactura = action.payload;
    },
    updateFilter: (state, action) => {
      state.filter = action.payload || {};
    },
    updatePagination: (state, action) => {
      state.metadata = { ...state.metadata, ...action.payload };
    },
    addFactura: (state, action) => {
      state.facturas.unshift(action.payload);
    },
    updateFactura: (state, action) => {
      const index = state.facturas.findIndex((f) => f.id === action.payload.id);
      if (index !== -1) {
        state.facturas[index] = action.payload;
      }
    },
    clearError: (state) => {
      state.error = null;
    },
    clearCurrentFactura: (state) => {
      state.currentFactura = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase("facturas/updateFactura/pending", (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase("facturas/updateFactura/fulfilled", (state, action) => {
        state.loading = false;
        // Update the factura in the list
        const index = state.facturas.findIndex((f) => f.id === action.payload.id);
        if (index !== -1) {
          state.facturas[index] = action.payload;
        }
      })
      .addCase("facturas/updateFactura/rejected", (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to update factura";
      })
      .addCase("facturas/createFactura/pending", (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase("facturas/createFactura/fulfilled", (state, action) => {
        state.loading = false;
        state.facturas.unshift(action.payload);
      })
      .addCase("facturas/createFactura/rejected", (state, action) => {
        state.loading = false;
        state.error = action.error?.message || "Failed to create factura";
      });
  }
});

export const {
  setLoading,
  setError,
  setFacturas,
  setClients,
  setCurrentFactura,
  updateFilter,
  updatePagination,
  addFactura,
  updateFactura,
  clearError,
  clearCurrentFactura
} = facturaSlice.actions;

// Selectors
export const selectAllFacturas = (state) => state.facturas.facturas;
export const selectClients = (state) => state.facturas.clients;
export const selectCurrentFactura = (state) => state.facturas.currentFactura;
export const selectMetadata = (state) => state.facturas.metadata;
export const selectFilter = (state) => state.facturas.filter;
export const selectLoading = (state) => state.facturas.loading;
export const selectError = (state) => state.facturas.error;

export default facturaSlice.reducer;
